import { render, staticRenderFns } from "./erw.vue?vue&type=template&id=3af36950&scoped=true&"
import script from "./erw.vue?vue&type=script&lang=js&"
export * from "./erw.vue?vue&type=script&lang=js&"
import style0 from "./erw.vue?vue&type=style&index=0&id=3af36950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af36950",
  null
  
)

export default component.exports